var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
export var PrimaryLinkStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: transparent;\n  border: 2px solid transparent;\n  border-radius: 3px;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: ", ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    color: ", ";\n    border: 2px solid ", ";\n    outline: none;\n  }\n\n  &:active {\n    color: ", ";\n    text-decoration: ", ";\n  }\n"], ["\n  color: ", ";\n  background-color: transparent;\n  border: 2px solid transparent;\n  border-radius: 3px;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: ", ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    color: ", ";\n    border: 2px solid ", ";\n    outline: none;\n  }\n\n  &:active {\n    color: ", ";\n    text-decoration: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? theme.colors.neutral7 : theme.colors.primary);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.65 : 1);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDark;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'underline');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral7;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'underline');
});
var PrimaryLink = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), PrimaryLinkStyles);
export default PrimaryLink;
var templateObject_1, templateObject_2;
//# sourceMappingURL=primaryLink.js.map